import _Object$values from 'babel-runtime/core-js/object/values';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { Base64 } from 'js-base64';

export default {
  props: {
    uiSchema: {
      type: Object,
      required: true
    },

    languageList: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      model: {
        __local: ''
      },
      innerModel: {},
      localLanguage: '',
      hasScene: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var schema = _.cloneDeep(this.uiSchema);
    _.each(schema.default, function (item, index) {
      if (index !== '__local') {
        _this.model = _extends({}, _this.model, _defineProperty({}, index, _extends({
          key: index
        }, item, {
          placeholder: item.value,
          value: ''
        })));
      }
    });

    this.hasScene = _Object$values(schema.default).some(function (item) {
      return _.isPlainObject(item) && item.scene;
    });
    if (this.hasScene) {
      this.cookSceneModel(schema);
    } else {
      this.cookStageModel();
    }
  },


  methods: {
    cookSceneModel: function cookSceneModel(schema) {
      var _this2 = this;

      // 获取场景列表
      var scenes = (_.uniqBy(_Object$values(schema.default).filter(function (item) {
        return _.isPlainObject(item);
      }), 'scene') || []).map(function (item) {
        return {
          scene: item.scene,
          title: item.scene
        };
      });
      if (_.isEmpty(scenes)) {
        // 如果 scenes 是空数组，则说明没有 scene，则直接把 schema.default 中的所有项目都放到一个 scene 中
        // 不需要 title，加一个假的场景是为了后续代码逻辑与有 scene 的情况一致
        scenes = [{
          scene: '___mock___scene___'
        }];
      }
      var firstScene = scenes[0];
      scenes.forEach(function (scene) {
        var sceneKey = scene.scene;
        _this2.innerModel[sceneKey] = {
          list: _.pickBy(_this2.model, function (item, key) {
            if (!_.isPlainObject(item)) return false;
            // 如果是横屏，则返回，只需要保留竖屏即可
            // 只有 ps 产出的素材才分横竖屏，而 ps 产出的素材是有 scene 属性的，所以 cookStageModel 那里不需要判断方向的逻辑
            if (_this2.getDirection(key) === 'H') return false;
            // 没有 scene 的分配给 game 场景
            if (sceneKey === firstScene.scene) {
              return item.scene === sceneKey || !item.scene;
            }
            return item.scene === sceneKey;
          }),
          title: scene.title
        };
      });
    },
    cookStageModel: function cookStageModel() {
      var _this3 = this;

      var stages = [{
        stage: 'start',
        title: this.$t('playTurbo.creative.languagePacks.leadSession')
      }, {
        stage: 'game',
        title: this.$t('playTurbo.creative.languagePacks.gameSession')
      }, {
        stage: 'ending',
        title: this.$t('playTurbo.creative.languagePacks.endSession')
      }];
      stages.forEach(function (stage) {
        var stageKey = stage.stage;
        _this3.innerModel[stageKey] = {
          list: _.pickBy(_this3.model, function (item, key) {
            if (!_.isPlainObject(item)) return false;
            if (_this3.getDirection(key) === 'H') return false;
            // 没有 stage 或 stage 不是 start、game 或 ending 的分配给 game 场景
            if (stageKey === 'game') {
              return item.stage === stageKey || !item.stage || !stages.map(function (j) {
                return j.stage;
              }).includes(item.stage);
            }
            return item.stage === stageKey;
          }),
          title: stage.title
        };
      });
    },
    isEmpty: function isEmpty(v) {
      return _.isEmpty(v);
    },
    decode: function decode(val) {
      return Base64.decode(val);
    },
    closeHandler: function closeHandler() {
      this.$emit('cancel');
    },
    okHandler: function okHandler() {
      var _this4 = this;

      this.$refs['language-form'].validate(function (valid) {
        if (valid) {
          console.log(_this4.model);
          _this4.$emit('submit', _this4.model);
        }
      });
    },
    inputHandler: function inputHandler(value, key) {
      var decodedKey = this.decode(key);
      var direction = this.getDirection(key);
      // 横竖屏同时修改
      if (direction) {
        var prefix = decodedKey.replace(/_V|_H$/i, '');
        // 以_V 或 _H 结尾时，先判断是否有数据
        if (this.model[Base64.encode(prefix + '_H')]) {
          this.model[Base64.encode(prefix + '_H')].value = value;
        }
        if (this.model[Base64.encode(prefix + '_V')]) {
          this.model[Base64.encode(prefix + '_V')].value = value;
        }
      } else {
        this.model[key].value = value;
      }
    },
    getDirection: function getDirection(key) {
      // 区分横竖屏文本
      var direction = '';
      var decodedKey = this.decode(key);
      if (/_v$/i.test(decodedKey)) {
        direction = 'V';
      } else if (/_h$/i.test(decodedKey)) {
        direction = 'H';
      }
      return direction;
    },
    getLabel: function getLabel(data) {
      var decodedKey = this.decode(data.key);
      // const direction = this.getDirection(data.key)
      // if (data.name) {
      //   return direction ? `${data.name}_${direction}` : data.name
      // }
      // return direction ? `${decodedKey}_${direction}` : decodedKey
      // 如果有 name 先使用 name，没有则使用属性 key
      return data.name || decodedKey;
    }
  }
};